var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 2C9.60139 2 7.65625 3.94514 7.65625 6.34459C7.65625 8.74404 9.60139 10.6892 12.0008 10.6892C14.4003 10.6892 16.3454 8.74404 16.3454 6.34459C16.3454 3.94514 14.4003 2 12.0008 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93359 12.189C6.0341 12.189 3.68359 14.5395 3.68359 17.439V18.75C3.68359 19.9926 4.69095 21 5.93359 21H14.3751V18.8751H12.002C10.7593 18.8751 9.75195 17.8677 9.75195 16.6251C9.75195 15.3824 10.7593 14.3751 12.002 14.3751H14.3751V12.189H8.93359Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6251 11.252C16.2109 11.252 15.8751 11.5877 15.8751 12.002V15.8751H12.002C11.5877 15.8751 11.252 16.2109 11.252 16.6251C11.252 17.0393 11.5877 17.3751 12.002 17.3751H15.8751V21.2489C15.8751 21.6631 16.2109 21.9989 16.6251 21.9989C17.0393 21.9989 17.3751 21.6631 17.3751 21.2489V17.3751H21.2489C21.6631 17.3751 21.9989 17.0393 21.9989 16.6251C21.9989 16.2109 21.6631 15.8751 21.2489 15.8751H17.3751V12.002C17.3751 11.5877 17.0393 11.252 16.6251 11.252Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlusIcon);
export default __webpack_public_path__ + "static/media/UserPlusIcon.c96eca79fec16172e21b3920bcd64b3c.svg";
export { ForwardRef as ReactComponent };